/**
 * Created by fwt on 2019-3-20.
 */
import React, {Component} from "react"
import {NavBar, Modal, Toast} from 'antd-mobile';
import {changeCheck, getRefundcharge, orderDetail, refund, getPhone, cancelOrder,refundRuncharge,refundRun,goodsOrderInfo,goodsGetcharge,goodsOrderCancle} from "../../../service/orderService";
import {
    busWxPay,
    cancelCityOrder,
    getCancelPic,
    newWxPay,
    shuttlePay,
    goodsPay,
    walletCode,
    walletBalance
} from "../../../service/homeService";
import moment from 'moment';
import {connect} from "react-redux";
import PayModal from "../../../components/PayModal";
import './style.less';
import TestCode from "../../../components/TestCode";
const sculpture = require('../../../common/image/sculpture.png');

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class OrderDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countDown: 0,
            disabled: false,
            range:false,
            detailData:[],
            payModal:false,
            payOrderId:"",
            formPay:"",
            payType:"",
            codeModal:false,
            getCodeDisabled: false,
            getCodeText: '重新获取',
            balance:"",
            lookImg:false,
            imgItem:"",
        }
    }

    componentDidMount() {
        walletBalance({token:this.props.userInfo.token,source:1}).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({balance:res.data.data.balance,})
            }
        });
        Toast.loading('正在加载',0);
        if(this.props.location.state.orderType == 7){
            this.getOrderDetail(this.props.match.params.id,this.props.location.state.orderType,goodsOrderInfo);
        }else{
            this.getOrderDetail(this.props.match.params.id,this.props.location.state.orderType,orderDetail);
        }
    }
    getOrderDetail = (orderNo,orderType,infoType) => {
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                id:orderNo,
                orderType:orderType,
            },
        };
        infoType(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                let timestamp = (new Date()).getTime();//获取当前时间戳
                let createTime = res.data.data.orderTime;
                this.setState({detailData:res.data.data});
                if (res.data.data.orderType == 1 && res.data.data.status === 4) {
                    let timeArea = moment(createTime).add(240, 'seconds').format('x') - timestamp;
                    this.setDownTime(parseInt(timeArea / 1000));
                }
            }else{
                Toast.info(res.data.msg,3)
            }
        }).catch(function (error) {
            console.log(error);
        })
    };

    //倒数计时
    setDownTime(time) {
        if (time <= 0) {
            this.setState({
                countDown: 0,
                disabled: true
            });
            Toast.info('支付过期，请重新下单');
        } else {
            let timer = setInterval(() => {
                time--;
                if (time > 0) {
                    this.setState({
                        countDown: time,
                    });
                } else {
                    this.setState({
                        countDown: 0,
                        disabled: true
                    });
                    Toast.info('支付过期，请重新下单');
                    clearInterval(timer);
                }
            }, 1000);
        }
    }
    //顶部行程状态
    routeStatus(type,orderId,isEvaluate){
        if(this.state.detailData.orderType == 19){
            switch(type){
                case 0 :
                    return<div  className="contentBox">
                        <div className="cue">申请成功！请耐心等待管理员联系</div>
                        <div className="change">
                            <div  onClick={() =>  Modal.alert('提示',
                                (<div className="refundText">您是否确认取消？</div>),
                                [{
                                    text: '取消',
                                    style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                                }, {
                                    text: '确认',
                                    onPress: () => this.cancel(orderId,),
                                    style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                                }]
                            )}>取消订单</div>
                        </div>
                    </div>;
                case 1 :
                    return<div  className="contentBox">
                        <div className="cue">行程未支付，请尽快支付订单！</div>
                        <div className="change">
                            <div style={{background:"#FF0000",border:'none',color:"#fff"}} onClick={()=> this.setState({payModal:true,payOrderId:orderId,payType:busWxPay})}>立即支付</div>
                            <div  onClick={() =>  Modal.alert('提示',
                                (<div className="refundText">您是否确认取消？</div>),
                                [{
                                    text: '取消',
                                    style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                                }, {
                                    text: '确认',
                                    onPress: () => this.cancel(orderId),
                                    style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                                }]
                            )}>取消订单</div>
                        </div>
                    </div>;
                case 4 :
                    return  (<div  className="contentBox">
                        <div className="cue">感谢您选择民途出行，期待您的再次光临！</div>
                       {/* <div className="range">
                            {isEvaluate == 1 ? <div className="evaluated">已评价</div>:<div onClick={()=>this.props.history.push("/gradeDriver",this.state.detailData)}>评价</div>}
                        </div>*/}
                    </div>);

            }
        }else if(this.state.detailData.orderType == 1){
            switch(true){
                case type == 4 :
                    if(this.state.disabled  == true){
                        return<div className="overtime">支付超时,订单已关闭！</div>
                    }else{
                        return<div  className="contentBox">
                            <div className="cue">剩余支付时间 <span>{this.state.countDown + 's'}</span></div>
                            <div className="pay">
                                <div onClick={()=>this.setState({payModal:true,payOrderId:orderId,payType:newWxPay})}>立即支付</div>
                            </div>
                        </div>
                    }

                case type == 6 && this.state.detailData.isChild == 0:
                    return  (<div className="contentBox">
                        <div className="cue">感谢您选择民途出行！请保持电话畅通，稍后司机会与您取得联系！</div>
                        <div className="change">
                            <div  onClick={() => this.goRefund(this.state.detailData.id,'refund',getRefundcharge)}>退票</div>
                            <div onClick={() => this.goRefund(this.state.detailData.id,'change')}>改签</div>
                        </div>
                    </div>);
                case type == 6 && this.state.detailData.isChild == 1:
                    return  (<div className="contentBox">
                        <div className="cue">感谢您选择民途出行！请保持电话畅通，稍后司机会与您取得联系！</div>
                        <div className="change">
                            <div  onClick={() => this.goRefund(this.state.detailData.id,'refund',getRefundcharge)}>退票</div>
                        </div>
                    </div>);
                case type == 11 :
                    return  (<div  className="contentBox">
                        <div className="cue">感谢您选择民途出行，期待您的再次光临！</div>
                        <div className="range">
                            {isEvaluate == 1 ? <div className="evaluated">已评价</div>:<div onClick={()=>this.props.history.push("/gradeDriver",this.state.detailData)}>评价</div>}
                        </div>
                    </div>);
                case type == 12 :
                    return  (<div className="contentBox">
                        <div className="cue">感谢您选择民途出行，祝您出行愉快！</div>
                        <div className="change">
                            <div  onClick={() => this.props.history.push("/refund",{orderId:this.state.detailData.id,tailoredType:1})}>退款进度</div>
                        </div>
                    </div>);

            }
        }else if(this.state.detailData.orderType == 2){
            switch(type){
                case 7 : case 77 :
                    return(<div  className="contentBox">
                                <div className="cue">行程未支付，请尽快支付订单！</div>
                                <div className="pay">
                                    <div onClick={()=> this.props.history.push('/RideCarPay',{orderId:orderId})}>立即支付</div>
                                </div>
                            </div>);
                case 0 : case 1 :
                    return  (<div className="contentBox">
                        <div className="cue">感谢您选择民途出行！请保持电话畅通，稍后司机会与您取得联系！</div>
                        <div className="change">
                            <div  onClick={() =>  Modal.alert('提示',
                                (<div className="refundText">您是否确认取消？</div>),
                                [{
                                    text: '取消',
                                    style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                                }, {
                                    text: '确认',
                                    onPress: () => this.cancelCity(orderId),
                                    style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                                }]
                            )}>取消订单</div>
                        </div>
                    </div>);
                case 2 : case 3 :
                return  (<div className="contentBox">
                    <div className="cue">感谢您选择民途出行！请保持电话畅通，稍后司机会与您取得联系！</div>
                    <div className="change">
                        <div  onClick={() =>{
                            let params = {
                                source:1,
                                token: this.props.userInfo.token,
                                data:{
                                    shuntOrderid:orderId,
                                },
                            };
                            getCancelPic(params).then((res)=>{
                                if(res.data.code == "0000"){
                                    Modal.alert('提示',
                                        (<div className="refundText">
                                            <div>您是否确认取消？</div>
                                            <div style={{color:"#616372",fontWeight:"initial"}}>本次主动取消订单将收取  <span style={{color:"#F79E24"}}>{res.data.data + "元"}</span>手续费 </div>
                                        </div>),
                                        [{
                                            text: '取消',
                                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                                        }, {
                                            text: '确认',
                                            onPress: () => this.cancelCity(orderId,res.data.data),
                                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                                        }]
                                    )
                                }
                            });
                        }}>取消订单</div>
                    </div>
                </div>);
                case 8 :
                    return  (<div  className="contentBox">
                        <div className="cue">感谢您选择民途出行，期待您的再次光临！</div>
                        <div className="range">
                            {isEvaluate == 1 ? <div className="evaluated">已评价</div>:<div onClick={()=>this.props.history.push("/gradeDriver",this.state.detailData)}>评价</div>}
                        </div>
                    </div>);
            }
        }else if(this.state.detailData.orderType == 5){
            switch(type){
                case 0 :
                    if(this.state.disabled  == true){
                        return<div className="overtime">支付超时,订单已关闭！</div>
                    }else{
                        return<div  className="contentBox">
                            <div className="cue">剩余支付时间 <span>{this.state.countDown + 's'}</span></div>
                            <div className="pay">
                                <div onClick={()=>this.setState({payModal:true,payOrderId:orderId,payType:shuttlePay})}>立即支付</div>
                            </div>
                        </div>
                    }
                case 1 : case 2 :
                    return  (<div  className="contentBox">
                        <div className="cue">感谢您选择民途出行！请保持电话畅通，稍后司机会与您取得联系！</div>
                        <div className="change">
                            <div  onClick={() =>  Modal.alert('提示',
                                (<div className="refundText">您是否确认取消？</div>),
                                [{
                                    text: '取消',
                                    style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                                }, {
                                    text: '确认',
                                    onPress: () => this.goRefund(this.state.detailData.id,'refund',refundRuncharge),
                                    style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                                }]
                            )}>取消订单</div>
                        </div>
                    </div>);
                case 4 :
                    return  (<div  className="contentBox">
                        <div className="cue">感谢您选择民途出行，期待您的再次光临！</div>
                        <div className="range">
                            {isEvaluate == 1 ? <div className="evaluated">已评价</div>:<div onClick={()=>this.props.history.push("/gradeDriver",this.state.detailData)}>评价</div>}
                        </div>
                    </div>);
                case 98 :
                    return  (<div className="contentBox">
                        <div className="cue">感谢您选择民途出行，祝您出行愉快！</div>
                        <div className="change">
                            <div  onClick={() => this.props.history.push("/refund",{orderId:this.state.detailData.id,tailoredType:5})}>退款进度</div>
                        </div>
                    </div>);
            }
        }else if(this.state.detailData.orderType == 7){
            switch(type){
                case 0 :
                    if(this.state.disabled  == true){
                        return<div className="overtime">支付超时,订单已关闭！</div>
                    }else{
                        return<div  className="contentBox">
                            <div className="cue">剩余支付时间 <span>{this.state.countDown + 's'}请立即支付以免超时！</span></div>
                            <div className="pay">
                                <div onClick={()=>this.setState({payModal:true,payOrderId:orderId,payType:goodsPay})}>立即支付</div>
                            </div>
                        </div>
                    }
                case 1 :
                return  (<div  className="contentBox">
                    <div className="cue">感谢您选择民途出行！请保持电话畅通，稍后司机会与您取得联系！</div>
                    <div className="change">
                        <div  onClick={() => this.goRefund(this.state.detailData.id,'refund',goodsGetcharge)}>退款</div>
                    </div>
                </div>);
            }
        }

    }
    //取消城内订单
    cancelCity(orderId,pic){
        let params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                operatorType:0,//操作员类型:0-乘客1-调度2-后台管理取消
                shuntOrderid:orderId,
                serviceCharge:pic,
            }
        };
        Toast.loading("",30);
        cancelCityOrder(params).then((res)=>{
            if(res.data.code == "0000"){
                if(res.data.data.totalPrice > 0){
                    this.props.history.push('/rideCar',{orderId:orderId});
                }else{
                    Toast.info("取消成功",3,()=>this.getOrderDetail(this.props.match.params.id,this.props.location.state.orderType,orderDetail));
                }
            }else{
                Toast.info(res.data.msg)
            }
        });
    }
    cancel(orderId){
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                id:orderId,
            },
        };
        cancelOrder(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("取消成功",3,()=>this.getOrderDetail(this.props.match.params.id,this.props.location.state.orderType,orderDetail));
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    }
    //标题状态
    titleStatus(detailData){
        const type = detailData.status;
        if(detailData.orderType == 19){
            return  (<div>订单详情</div>);
        }else if(detailData.orderType == 2){
            switch(type){
                case 0 :
                    return  (<div>未接单</div>);
                case 1 :
                    return  (<div>已接单</div>);
                case 2: case 3: case 4 :
                    return  (<div>行程中...</div>);
                case 6 :
                    return  (<div>待司机确认</div>);
                case 7 :case 77 :
                    return  (<div>待支付</div>);
                case 8 :
                    return  (<div>行程已完成</div>);
                case 99 :
                    return  (<div>行程已取消</div>);
            }
        }else if(detailData.orderType == 1){
            switch(type){
                case 4 :
                    return  (<div>未支付</div>);
                case 6 :
                    return  (<div>行程未开始</div>);
                case 8 :
                    return  (<div>行程中...</div>);
                case 9 :
                    return  (<div>行程已改签</div>);
                case 10 :
                    return  (<div>行程已取消</div>);
                case 11 :
                    return  (<div>行程已完成</div>);
                case 12 :
                    return  (<div>行程已退票</div>);
            }
        }else if(detailData.orderType == 5){
            switch(type){
                case 0 :
                    return  (<div>未支付</div>);
                case 1:case 2:
                    return  (<div>待出行</div>);
                case 3:
                    return  (<div>行程中...</div>);
                case 4 :
                    return  (<div>行程已完成</div>);
                case 98 :
                    return  (<div>订单已退款</div>);
                case 99 :
                    return  (<div>行程已取消</div>);
            }
        }else if(detailData.orderType == 7){
            switch(type){
                case 0 :
                    return  (<div>未支付</div>);
                case 1:
                    return  (<div>待出行</div>);
                case 2:
                    return  (<div>行程中...</div>);
                case 4 :
                    return  (<div>行程已完成</div>);
                case 98 :
                    return  (<div>订单已退款</div>);
                case 99 :
                    return  (<div>行程已关闭</div>);
            }
        }

    }


    goRefund = (orderId,type,chargeName) => {
        if(type === 'refund'){
            Toast.loading("",0);
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{
                    id:orderId,
                }
            };
            chargeName(params).then((res)=>{
                if(res.data.code === '0000'){
                    Toast.hide();
                    Modal.alert('温馨提示',
                        (<div className="refundText">
                            <p>您是否确认退票？</p>
                            <p className="refundBox">本次退票将收取<span>{res.data.data.charge}</span>元手续费用 </p>
                        </div>),
                        [{
                            text: '取消',
                            style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                        }, {
                            text: '确认',
                            onPress: () => this.refundApply(orderId,type,res.data.data.charge,chargeName),
                            style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                        }]
                    );
                }else{
                    Toast.info(res.data.msg,3)
                }
            })
        }
        if(type === 'change'){
            Modal.alert('温馨提示',
                (<div className="refundText">
                    <div>您是否确认改签？</div>
                    <div className="refundBox">改签班次将收取一定手续费</div>
                </div>),
                [{
                    text: '取消',
                    style: {color: '#616880', backgroundColor: '#f9f9f9', fontSize: '16px',height:"48px"}
                }, {
                    text: '确认',
                    onPress: () => this.refundApply(orderId,type),
                    style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                }]
            );
        }

    };
    refundApply(orderId,type,charge,chargeName){
        let refundName = "";
        if(chargeName == refundRuncharge){
            refundName = refundRun
        }else{
            refundName = refund
        }
        if(type === 'change'){
            let params = {
                source:1,
                token: this.props.userInfo.token,
                data:{id:orderId,}
            };
            // console.log(this.state.detailData)
            // return;
            changeCheck(params).then((res)=>{
                if(res.data.code === '0000'){
                    this.props.history.push('/selectShift',this.state.detailData)
                }else{
                    Toast.info(res.data.msg,3)
                }
            });
        }
        // if(type === 'change'){
        //     this.props.history.push('/selectShift',this.state.detailData)
        // }
        if(type === 'refund'){
            Toast.loading("正在加载",0);
            if(chargeName == goodsGetcharge){
                let params = {
                    source:1,
                    token: this.props.userInfo.token,
                    data:{id:orderId,charge:charge,cancleOperatorType:0,}
                };
                goodsOrderCancle(params).then((res)=>{
                    if(res.data.code === '0000'){
                        Toast.info("操作成功",2,()=>this.getOrderDetail(orderId,this.props.location.state.orderType,goodsOrderInfo))
                    }else{
                        Toast.info(res.data.msg,3)
                    }
                });
            }else{
                let params = {
                    source:1,
                    token: this.props.userInfo.token,
                    data:{id:orderId, charge:charge,}
                };
                refundName(params).then((res)=>{
                    if(res.data.code === '0000'){
                        Toast.info("操作成功",2,()=>this.getOrderDetail(orderId,this.props.location.state.orderType,orderDetail))
                    }else if(res.data.code === '9999'){
                         // 修改弹窗提示
                         Toast.hide();
                         Modal.alert('提示',
                            (<div className="refundText">
                                <div className="refundBox noPadding">操作频繁,请稍后再试!</div>
                            </div>),
                            [{
                                text: '确认',
                                style: {color: '#fff', backgroundColor: '#3679FE', fontSize: '16px',height:"48px"}
                            }]
                        );
                    }else{
                        Toast.info(res.data.msg,3)
                    }
                })
            }

        }
    }
    //立即支付
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.goPay("icbcjft")
        }
        if(e== "微信支付"){
            this.goPay("wx")
        }
        if(e == "民途钱包余额支付"){
            if(this.state.getCodeText !== "重新获取"){
                Toast.info(this.state.getCodeText,3);
                return
            }
            this.getCode();
        }
    }
    goPay (type,v)  {
        Toast.loading("",0);
        const params = {
            source: 1,
            token:this.props.userInfo.token,
            data:{
                source: 1,
                orderId: this.state.payOrderId,
                payChannel:type,
                smsCode:v,
            }
        };
        this.state.payType(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                if(type == "wx"){
                    this.wxBridgeReady(res.data.data);
                }else if(type == "wallet"){
                    if(this.props.location.state.orderType == 7){
                        this.getOrderDetail(this.props.match.params.id,this.props.location.state.orderType,goodsOrderInfo);
                    }else{
                        this.getOrderDetail(this.props.match.params.id,this.props.location.state.orderType,orderDetail);
                    }
                    this.onClose();
                }else{
                    // window.location.href = res.data.data.qrcode;
                    this.setState({formPay:res.data.data});
                    this.onClose();
                }
            } else {
                Toast.info(res.data.msg);
            }
        })
    };
    wxBridgeReady = (bridgeInfo) => {
        const self = this;

        function onBridgeReady() {
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                    "appId": bridgeInfo.appId,         //公众号名称，由商户传入
                    "timeStamp": bridgeInfo.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr": bridgeInfo.nonceStr,   //随机串
                    "package": bridgeInfo.package,     //prepay_id
                    "signType": bridgeInfo.signType,   //微信签名方式
                    "paySign": bridgeInfo.sign         //微信签名
                },
                function (r) {
                    // alert(JSON.stringify(r));
                    if (r.err_msg === "get_brand_wcpay_request:ok") {
                        if(self.props.location.state.orderType == 7){
                            self.getOrderDetail(self.props.match.params.id,self.props.location.state.orderType,goodsOrderInfo);
                        }else{
                            self.getOrderDetail(self.props.match.params.id,self.props.location.state.orderType,orderDetail);
                        }
                        self.onClose();
                    } else if (r.err_msg == "get_brand_wcpay_request:fail") {
                        Toast.info('支付失败，请稍后重试');
                    }
                }
            );
        }

        if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
        } else {
            onBridgeReady();
        }
    };

    onClose = () => {
        this.setState({payModal:false});
    };
    payFrom(){
        if(this.state.formPay !== ""){
            return(
                <form
                    name="auto_submit_form"
                    method="post"
                    action={this.state.formPay.url}>
                    <input
                        type="hidden"
                        name="biz_content"
                        value={this.state.formPay.bizContent} />
                    <input type="submit" value="立刻提交" style={{display:"none"}} onClick={setTimeout(()=>document.forms[0].submit(),100)}/>
                </form>
            )
        }else{
            return null
        }
    }
    callPhone(id){
        let params={
            source: 1,
            token:this.props.userInfo.token,
            data:{
                id: id,
            }
        };
        getPhone(params).then((res)=>{
            if(res.data.code == '0000'){
                window.location.href = `tel://${res.data.data.middleNumber}`;
            }else{
                Toast.info(res.data.msg,2)
            }
        })
    }
    getPayWay(e){
        if(e == "wx"){
            return "微信"
        }
        if(e == "icbc"){
            return "工行支付"
        }
        if(e == null){
            return "未支付"
        }
    }
    getTripInfo(detailData){
        if(detailData.orderType == 19){
            return <div className="contentBox">
                <div className="firstPart">
                    <div>行程信息：{detailData.shiftNum}</div>
                </div>
                <div className="secondPart">
                    <div><i className="icon iconfont iconsanjiaoxing"/></div>
                    <div>{detailData.orderGenre == 0 ? '单程包车':detailData.orderGenre == 1 ? '往返包车' : '按天包车'}  {detailData.passengerNum + '人'} </div>
                </div>
                <div className="secondPart">
                    <div><i className="icon iconfont iconshijian"/></div>
                    <div>{detailData.startDate} {detailData.startTime}</div>
                </div>
                <div className="secondPart">
                    <div><i className="icon iconfont iconchufadi"/></div>
                    <div>{detailData.startCity+"—"+detailData.endCity}</div>
                </div>
            </div>
        }else if(detailData.orderType == 7){
            return <div className="contentBox">
                <div className="firstPart">
                    <div>货物信息</div>
                </div>
                <div className="secondPart">
                    <div>发出站点</div>
                    <div>{detailData.startAddress}</div>
                </div>
                <div className="secondPart">
                    <div>到达站点</div>
                    <div>{detailData.endAddress}</div>
                </div>
                <div className="secondPart" style={{margin:0}}>
                    <div>发班时间</div>
                    <div>{detailData.startTime}</div>
                </div>
                <div className="secondPart">
                    <div>货物类型</div>
                    <div>{detailData.logisticsType}</div>
                </div>
                <div className="secondPart">
                    <div>货物重量</div>
                    <div>{detailData.logisticsWeight}kg</div>
                </div>
                <div className="secondPart">
                    <div>寄&nbsp;&nbsp;件&nbsp;&nbsp;人</div>
                    <div>{detailData.senderPhone}</div>
                </div>
                <div className="secondPart">
                    <div>收&nbsp;&nbsp;件&nbsp;&nbsp;人</div>
                    <div>{detailData.recipientsPhone}</div>
                </div>
                <div className="secondPart">
                    <div>备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 注</div>
                    <div>{detailData.recipientsPhone}</div>
                </div>
            </div>
        }else{
            return <div className="contentBox">
                <div className="firstPart">
                    <div>行程信息：{detailData.shiftNum} </div>
                </div>
                <div className="secondPart">
                    <div><i className="icon iconfont iconshijian"/></div>
                    <div>{detailData.startDate} {detailData.startTime}</div>
                </div>
                <div className="secondPart">
                    <div><i className="icon iconfont iconchufadi"/></div>
                    <div>{detailData.startAddress == null ? detailData.startCity : detailData.startCity+"."+detailData.startAddress }</div>
                </div>
                <div className="secondPart">
                    <div><i className="icon iconfont iconmudedi"/></div>
                    <div>{detailData.endAddress == null ? detailData.endCity : detailData.endCity+"."+detailData.endAddress}</div>
                </div>
            </div>
        }
    }
    // 倒数计时
    setTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeDisabled: true,getCodeText: time + 's后获取'});
            } else {
                this.setState({getCodeText: '重新获取'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    getCode(){
        let params={
            token:this.props.userInfo.token,
            source:1,
            data:{
                source:3,
            }
        };
        walletCode(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setTime(60);
                this.setState({codeModal:true});
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    codeSubmit(v){
        if(v == ""){
            Toast.info("请输入验证码");
            return
        }
        this.setState({codeModal:false,});
        this.goPay("wallet",v);
    }
    bigImg(v){
        this.setState({ lookImg: true,imgItem: v})
    }
    render() {
        const {detailData} =this.state;
        if(detailData == "" || detailData == null){
            return null
        }
        return (
            <div className="orderDetail">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >{this.titleStatus(detailData)}</NavBar>

                <div className="content">
                    <div className="myOrderDetails">
                        {this.routeStatus(detailData.status,detailData.id,detailData.isEvaluate)}
                    </div>
                    {
                        detailData.driverName == null ? null : (
                            <div className="driver">
                                <div><img src={detailData.driverAvatar}/></div>
                                <div className="driverInfo">
                                    <div>{detailData.driverName} <i className="icon iconfont iconpingfenxianshi" /><span>{detailData.stars}分</span> </div>
                                    <div>{detailData.carNum}</div>
                                    <div>{detailData.carModel}</div>
                                </div>
                                <div>
                                    <a href={`tel:${detailData.dispatcherPhone}`}><i className="icon iconfont icondingdanxiangqingdianhua" /></a>
                                    {/*<span onClick={()=>this.callPhone(detailData.id)}><i className="icon iconfont icondingdanxiangqingdianhua" /></span>*/}
                                </div>
                            </div>
                        )
                    }
                    {this.getTripInfo(detailData)}

                    {
                        detailData.orderType == 1  ? (
                            <div className="passenger orderInfo">
                                <div className="firstPart">
                                    <div>乘客信息</div>
                                </div>
                                <div className="secondPart">
                                    <div>
                                        <div>{detailData.seatNum}</div>
                                        <div className="pic">￥{detailData.price}</div>
                                    </div>
                                    <div>
                                        <div>乘车人</div>
                                        <div>{detailData.passengerName}</div>
                                    </div>
                                    <div>
                                        <div>乘客类型</div>
                                        <div>{detailData.isChild == 1 ? "儿童" : "成人"}</div>
                                    </div>
                                    <div>
                                        <div>手机号码</div>
                                        <div>{detailData.passengerPhone}</div>
                                        {/*<div>{detailData.passengerPhone.substr(0,3)+'****'+detailData.passengerPhone.substr(7)}</div>*/}
                                    </div>
                                    <div>
                                        <div>证件类型</div>
                                        <div>{detailData.idType}{detailData.idNum == null ? null:(detailData.idType == '身份证' ? detailData.idNum.substr(0,4)+'**********'+detailData.idNum.substr(14) : detailData.idNum)}</div>
                                    </div>
                                    <div>
                                        <div>体温</div>
                                        <div>{detailData.temperature + " ℃"}</div>
                                    </div>
                                    <div>
                                        <div>健康码</div>
                                        <img className="code" src={detailData.photo} onClick={()=>this.bigImg(detailData.photo)}/>
                                    </div>
                                </div>
                            </div>
                        ) :  null
                    }

                    <div className="orderInfo">
                        <div className="firstPart">
                            <div>订单信息</div>
                        </div>
                        <div className="secondPart">
                            {
                                detailData.orderType == 5 ? (
                                    <div>
                                        <div>预约车型：</div>
                                        <div className="oderNum">{detailData.carModelName}</div>
                                    </div>
                                ):null
                            }
                            <div>
                                <div>订单价格：</div>
                                <div className="oderNum">{detailData.price == null ? null : '￥' + detailData.price}</div>
                            </div>
                            <div>
                                <div>订单编号：</div>
                                <div className="oderNum">{detailData.orderNum}</div>
                            </div>
                            <div>
                                <div>下单时间：</div>
                                <div>{detailData.createTime}</div>
                            </div>
                            <div>
                                <div>支付方式：</div>
                                <div>
                                    {this.getPayWay(detailData.payWay)}
                                </div>
                            </div>
                            <div className="description">
                                <div>订单备注：</div>
                                <div className="oderNum">{detailData.description}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    detailData.orderType == 1 && detailData.status == 6 ? <div className="btn" onClick={()=>this.props.history.push(`/editPassengerInfo`,detailData)}><button>修改乘客信息</button></div>:null
                }

                {/* {
                    this.state.orderInfo.payStatus === 0 ? (
                        <div className="footer">
                            <div className="payTotal">
                                总计：<span>￥{(this.state.orderInfo.totalPay - this.state.orderInfo.score).toFixed(2)}</span>
                            </div>
                            <button disabled={this.state.disabled}
                                    onClick={() => this.weiXinPay(this.props.match.params.id)}>{this.state.disabled == true ?
                                <div>支付超时</div> : <div>立即支付(剩余支付时间：{this.state.countDown}s)</div>}</button>
                        </div>

                    ) : null
                } */}
                <PayModal
                    modal={this.state.payModal}
                    onClose={this.onClose.bind(this)}
                    payType={this.payType.bind(this)}
                    businessType={detailData.orderType == 1 ? "intercity" : undefined}
                    balance={this.state.balance}
                />
                {this.payFrom()}
                <TestCode
                    modal={this.state.codeModal}
                    onClose={()=>this.setState({codeModal:false})}
                    againEvent={this.getCode.bind(this)}
                    getCodeDisabled={this.state.getCodeDisabled}
                    getCodeText={this.state.getCodeText}
                    codeSubmit={this.codeSubmit.bind(this)}
                />
                <Modal
                    className="lookImgModal"
                    visible={this.state.lookImg}
                    transparent
                    onClose={()=>this.setState({lookImg:false})}
                >
                    <img src={this.state.imgItem} />
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Order/OrderDetail/index.js